var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"tag tag-default float-xs-right",class:_vm.spanClass},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }